import { queueActions } from './queue-slice';
import { getData } from '../common-actions';
import { fetchQueues } from '../../lib/api';

export const getQueues = (token, signal) => {

  return getData({
    token: token,
    actions: queueActions,
    fetchFn: (token) => fetchQueues(token, signal),
    dataKey: "queues",
    name: "get queues",
    setFunctionName: "setQueues"
  });
};